export default __webpack_public_path__ + "static/media/hht2_ep14_speaking_04.918a58af.png";